import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { EASE_IN_OUT } from './ease';

function alreadySeen() {
  try {
    return sessionStorage.getItem('salt2Intro') === '1';
  } catch {
    return true;
  }
}

/** ヒーロー側の導入ディレイ計算に使う（プリローダーと同じ判定を共有） */
export function introDelay(extra = 0) {
  if (typeof window === 'undefined') return extra;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
  return (alreadySeen() ? 0.1 : 1.5) + extra;
}

/**
 * 初回訪問時のみのカウンタープリローダー（セッション内1回、約1.9秒で退場）。
 */
export default function Preloader() {
  // ビルド時に書き出す HTML（scripts/prerender.js）には入れない。入れると、この画面を出さない人（2回目・動きを減らす設定）や
  // JavaScript を動かさない読み手にも、全画面の読み込み画面が見えてしまう
  const [show, setShow] = useState(
    () =>
      typeof window !== 'undefined' &&
      !window.__SALT2_PRERENDER__ &&
      !alreadySeen() &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!show) return undefined;
    const t0 = performance.now();
    const dur = 1000;
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(Math.round(eased * 100));
      if (p < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setTimeout(() => {
          setShow(false);
          try {
            sessionStorage.setItem('salt2Intro', '1');
          } catch {
            /* noop */
          }
        }, 180);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[999] flex flex-col justify-between bg-paper px-6 pb-6 pt-7 md:px-10"
          exit={{ y: '-100%' }}
          transition={{ duration: 0.75, ease: EASE_IN_OUT }}
          aria-hidden="true"
        >
          <img src="/icon/SALT2_logo_black.png" alt="" className="h-6 w-auto self-start" />
          <div className="flex items-end justify-between">
            <span className="pb-3 text-[11px] font-semibold uppercase tracking-label text-gray-500">
              AI Professional Firm — Tokyo
            </span>
            <span className="display-type text-[88px] leading-none text-ink tnum md:text-[132px]">
              {count}
            </span>
          </div>
          <span
            className="absolute bottom-0 left-0 h-[3px] bg-accent"
            style={{ width: `${count}%` }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
